import React from 'react';
import { ArrowRight } from 'lucide-react';

const FinalCTA = () => {
  return (
    <section id="audit" className="py-20 md:py-28">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-[32px] p-10 md:p-16 text-center" style={{ background: 'linear-gradient(135deg, #1c1917 0%, #292524 100%)' }}>
          {/* decorative shapes */}
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-[#F97316]/20 blur-3xl"></div>
          <div className="absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-[#4F46E5]/25 blur-3xl"></div>

          <div className="relative">
            <p className="text-[12px] font-bold uppercase tracking-widest text-[#F97316] mb-4">Free • 60 seconds</p>
            <h2 className="text-[36px] md:text-[52px] font-extrabold text-white leading-[1.05] max-w-2xl mx-auto">
              See where you actually rank on the map today.
            </h2>
            <p className="mt-5 text-[16px] text-stone-300 max-w-xl mx-auto">
              A live heatmap of your Google Business Profile across 49 points around your location. No credit card, no sales call.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <button
                onClick={() => document.querySelector('input')?.focus()}
                className="px-7 py-4 text-[14px] font-bold text-stone-900 bg-white rounded-xl hover:bg-stone-100 hover:-translate-y-0.5 transition inline-flex items-center gap-2"
              >
                Run my free heatmap <ArrowRight size={16} />
              </button>
              <a href="/pricing" className="px-7 py-4 text-[14px] font-bold text-white border border-white/20 rounded-xl hover:bg-white/5 transition">
                See pricing
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
